import Filter from '@components/Filter';
import styled from '@emotion/styled';
import { GetDownloadableCouponsParams } from '@models/coupon';

interface Props {
    sorter: GetDownloadableCouponsParams['sorter']
    setSorter: (v: GetDownloadableCouponsParams['sorter']) =>void;
}

function CouponFilter({ sorter, setSorter }:Props) {
  return (
        <Wrapper>
            <Filter title='보기 설정' sort={sorter}
                    setSort={setSorter}
                    sortItems={[
                      { value: 'CreatedAtAsc', label: '등록순' },
                      { value: 'EndAtAsc', label: '마감 임박순' },
                    ]} />
        </Wrapper>
  );
}

const Wrapper = styled.div`
    padding: 12px 16px;
`;

export default CouponFilter;
